export const PRICE_NO_EMAIL = 0.10;  // 10 cents per entry without email
export const PRICE_WITH_EMAIL = 0.30; // 30 cents per entry with email


//make sure to update backend price file too for stripe.js to work